// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";

function ErrorComponent(props) {
  var __cvcError = props.cvcError;
  var __expiryError = props.expiryError;
  var __cardError = props.cardError;
  var __errorStr = props.errorStr;
  var errorStr = __errorStr !== undefined ? Caml_option.valFromOption(__errorStr) : undefined;
  var cardError = __cardError !== undefined ? __cardError : "";
  var expiryError = __expiryError !== undefined ? __expiryError : "";
  var cvcError = __cvcError !== undefined ? __cvcError : "";
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var match$1 = match.config.appearance;
  var innerLayout = match$1.innerLayout;
  var errorTextStyle_color = themeObj.colorDangerText;
  var errorTextStyle_fontSize = themeObj.fontSizeSm;
  var errorTextStyle_textAlign = "left";
  var errorTextStyle_alignSelf = "start";
  var errorTextStyle = {
    color: errorTextStyle_color,
    fontSize: errorTextStyle_fontSize,
    textAlign: errorTextStyle_textAlign,
    alignSelf: errorTextStyle_alignSelf
  };
  var isSpacedErrorShown = errorStr !== undefined ? errorStr.length > 0 : false;
  var isCompressedErrorShown = innerLayout === "Compressed" && (cardError !== "" || expiryError !== "" || cvcError !== "");
  if (innerLayout === "Spaced") {
    return React.createElement(RenderIf$OrcaPaymentPage.make, {
                condition: isSpacedErrorShown,
                children: React.createElement("div", {
                      className: "Error pt-1",
                      style: errorTextStyle
                    }, Belt_Option.getWithDefault(errorStr, ""))
              });
  } else {
    return React.createElement(RenderIf$OrcaPaymentPage.make, {
                condition: isCompressedErrorShown,
                children: React.createElement("div", {
                      className: "Error pt-1",
                      style: errorTextStyle
                    }, "Invalid input")
              });
  }
}

var make = ErrorComponent;

export {
  make ,
}
/* jotai Not a pure module */
